import React from "react";


const USARegister = () => {
    return (
        <>
        
        <iframe id="JotFormIFrame-223368512844156" title="Jobseeker Onboarding" onload="window.parent.scrollTo(0,0)"
         allowtransparency="true" allow="geolocation; microphone; camera; fullscreen" 
         src="https://form.jotform.com/223368512844156" frameborder="0" 
         style={{
            minWidth: '100%',
            maxWidth: '100%',
            height: '1800px',
            border: 'none',
            background: 'linear-gradient(to right, #0E1E3B, #4E1333)',
          }} scrolling="no" > </iframe> 
          <script src='https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js'></script> 
          <script>window.jotformEmbedHandler("iframe[id='JotFormIFrame-223368512844156']", 
            "https://form.jotform.com/")</script>
        
        </>
    )
}

export default USARegister;